import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEmptySet } from '@fortawesome/pro-solid-svg-icons';

import clsx from 'clsx';
import { useSimulationId } from '../../../GanttSimulation/hooks';
import { useIsMutating } from '@tanstack/react-query';
import { publishTaskMutationKey } from '../../../../../../queryHooks/productionPlanHooks';
import { CircularProgress } from '@nexelem/components';

type SimulationNotPublishedIconProps = {
  nodeId: number;
  toPublish: boolean;
  className?: string;
};
export const SimulationNotPublishedIcon = ({ nodeId, toPublish, className }: SimulationNotPublishedIconProps) => {
  const simulation = useSimulationId();
  const publishTaskMutation = useIsMutating({ mutationKey: publishTaskMutationKey(simulation.id, nodeId) });

  if (!simulation.id) {
    return null;
  }

  if (publishTaskMutation) {
    return <CircularProgress className={className} size={15} />;
  }

  if (!toPublish) {
    return <FontAwesomeIcon className={clsx('size-4 text-icon-disabled', className)} icon={faEmptySet} />;
  }

  return null;
};
